export enum CategoryType {
  call_history = "call_history",
  organization = "organization",
  partner = "partner",
  product = "product",
  task = "task",
  ticket = "ticket",
  gallery_item = "gallery_item",
  reply_template = "reply_template",
  payment_item_category = "payment_item_category",
  payment_item_group = "payment_item_group",
  payment_item_type = "payment_item_type",
  lead_follow_up_category = "lead_follow_up_category",
  auto_dial_category = "auto_dial_category",
}
